<template>
    <div class="container container-fluid">
        <h1 class="page-heading">Main Nav</h1>

        <aha-main-nav></aha-main-nav>
    </div>
</template>

<script>
    import Component from '../../components/component.vue';
    import MainNav from '../../components/nav/main-nav.vue';

    export default {
        components: {
            ahaComponent: Component,
            ahaMainNav: MainNav
        }
    }
</script>


// WEBPACK FOOTER //
// demo/pages/components/main-nav.vue